import { observable } from "mobx";

/**
* RacingTrackInfo defines additional information from the feed for the event
*
* @typedef RacecardLineInfo
* @type {Object}
* @property {lineId} Unique identifier
* @property {competitorName} Name of the horse
* @property {trainer} Name of trainer
* @property {stall} number of stall
* @property {date} date of the event
* @property {competitorNumber} number of the horse
* @property {qaeventId} eventId of HR event
* @property {leagueId} id of the league
* @property {rule4Deduction} show if the line has rule for deduction
* @property {rpr} Racing post ratings
* @property {diomedComment} comment for the  line
* @property {silkData} silk image
*/

export class RacecardLineInfo {
    lineId: string;
    @observable  competitorName?: string;
    @observable trainer?: string;
    @observable jockey?: string;
    @observable stall?: number;
    date: Date;
    @observable competitorNumber?: number;
    qaEventId: string;
    leagueId: string;
    @observable rule4Deduction?: string;
    @observable rpr?: string;
    @observable diomedComment?: string;
    @observable silkData?: string;

    constructor(source: RacecardLineInfo) {
        this.lineId = source.lineId;
        this.competitorName = source.competitorName;
        this.trainer = source.trainer;
        this.jockey = source.jockey;
        this.stall = source.stall;
        this.date = source.date;
        this.competitorNumber = source.competitorNumber;
        this.qaEventId = source.qaEventId;
        this.leagueId = source.leagueId;
        this.rule4Deduction = source.rule4Deduction;
        this.rpr = source.rpr;
        this.diomedComment = source.diomedComment;
        this.silkData = source.silkData;
    }
}